import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import {TweenMax, Linear} from "gsap";
import * as PIXI from "pixi.js";
import MoneyFormat from "Base/MoneyFormat";
import EntryPoint from "../../../../engine/src/EntryPoint";

export default class LineWinningContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
        this.createTweens();
        this.hide();
    }

    init() {
        //this.valueText = this.getChildByName('valueText');
        //this.valueText = new PIXI.BitmapText('100500', {font: {name: 'bigWinFont', size: '110px'}, align: 'center'});

        this.valueText = new PIXI.BitmapText('1234567890.,', {font:{name:'winningFont', size: '80px'}, align:'center'});
        this.valueText.anchor.set(0.5, 0.5);
        this.valueText.y -= 20;
        let sss = this.getChildByName('valueText');
        sss.destroy();
        this.addChild(this.valueText);
    }

    addListeners() {
        GlobalDispatcher.add('winningsController:slowWin', this.onShowWinning, this);

    }

    createTweens() {
        this.tween = TweenMax.fromTo(this.scale, 0.5, {x:0, y:0}, {x:1, y:1, paused:true, ease:Linear.easeNone});
    }

    onValueUpdate() {
        this.valueText.text = MoneyFormat.format(this.value, false);
    }

    onShowWinning(event) {
        if (!event.params.win || EntryPoint.PostMessages.winLessOrEqualToBet()) {
            this.hide();
            return;
        }

        this.targetValue = event.params.win;
        this.value = 0;
        this.valueText.text = MoneyFormat.format(this.value, false);
        this.tween.play(0);

        TweenMax.fromTo(this, 0.5, {value:0},
            {value:this.targetValue, ease:Linear.easeNone, onUpdate:this.onValueUpdate, callbackScope:this});
    }

    show() {
        this.visible = true;
    }

    hide() {
        TweenMax.killTweensOf(this);
        this.visible = false;
    }
}